import React from "react";
import styled from "styled-components";

export default styled.section`
    z-index: 10;
    width: 81px;
    height: 100%;
    background: white;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    border-right: 1px solid #979797;
    box-shadow: 0px 0px 25px #00000038;
    transform: translate3d(0,0,0);
    overflow:hidden;
    -webkit-overflow-scrolling:touch;
`;